@if (entities(); as rows) {
  <table class="table table-striped table-sm" [class.report-table-padded]="printVersion()">
    <thead>
      <tr>
        <th style="width: 15%">{{ 'company_page.payment_remarks_card.table.date' | translate }}</th>
        <th style="width: 20%">{{ 'company_page.payment_remarks_card.table.sum' | translate }}</th>
        <th>{{ 'company_page.payment_remarks_card.table.creditor' | translate }}</th>
        <th>{{ 'company_page.payment_remarks_card.table.case_number' | translate }}</th>
        <th>{{ 'company_page.payment_remarks_card.table.source' | translate }}</th>
        <th>{{ 'company_page.payment_remarks_card.table.status' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      @for (row of rows; track row.uuid) {
        <tr>
          <td>{{ row.date | date }}</td>
          <td>{{ row.sum | accountsNumber: 1 }}</td>
          <td>{{ row.creditor }}</td>
          <td>{{ row.caseNumber }}</td>
          <td>{{ row.source }}</td>
          <td>
            @for (status of row.statuses; track status) {
              <span class="tag tag-dense me-1">{{ status | translate }}</span>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
}
